import { render } from "./SubmoduleTab.vue?vue&type=template&id=71940c2e&scoped=true&ts=true"
import script from "./SubmoduleTab.vue?vue&type=script&lang=ts"
export * from "./SubmoduleTab.vue?vue&type=script&lang=ts"

import "./SubmoduleTab.vue?vue&type=style&index=0&id=71940c2e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/webapp/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71940c2e"]])

export default __exports__